<template>
  <section id="contact">
    <card
      v-for="(item, index) in company"
      :key="index"
      :notAsset="true"
      :image="item.urlToImage"
      :right="index % 2 === 0"
      :portrait="index > 0"
      :noZoom="true"
    >
      <section>
        <h3>{{ item.title }}</h3>
        <separator width="190px" backgroundColor="black" height="2px" />
        <div class="contactText" v-html="item.content" />

        <div class="form form-std" style="width: 99%;">
          <spinner
            local
            overlay
            v-if="question[index].sending"
            text="Frågan skickas.."
          />
          <label> Din Email: </label>
          <input
            v-model="question[index].email"
            placeholder="exempel@mail.com"
            v-on:keyup.enter="$refs.question.focus()"
          />
          <label> Din fråga: </label>
          <textarea
            v-model="question[index].question"
            :enableFeedback="true"
            placeholder="Jag undrar..."
            ref="question"
          />
          <custom-button
            :disabled="
              !question[index].email === '' || question[index].question === ''
            "
            @click="sendQuestion(index)"
            primary
            >Skicka</custom-button
          >
          <p
            v-if="questionFlag.state !== 0"
            :class="{
              errorMessage: questionFlag.state === 2,
              confirmMessage: questionFlag.state === 1
            }"
          >
            <font-awesome-icon
              :icon="[
                'fas',
                questionFlag.state === 2
                  ? 'exclamation-triangle'
                  : 'check-circle'
              ]"
              class="icon"
            ></font-awesome-icon>
            {{ questionFlag.msg }}
          </p>
        </div>
      </section>
    </card>
  </section>
</template>

<script>
import Card from '@/components/Card.vue'
import Separator from '@/components/Separator.vue'
import Spinner from '@/components/Spinner.vue'

import { mapGetters, mapActions } from 'vuex'
import userHandler from './../services/userHandler'
import logFile from '@/script/log'
const log = logFile('company')

export default {
  components: {
    Card,
    Separator,
    Spinner
  },
  data () {
    return {
      company: [],
      question: []
    }
  },
  async created () {
    try {
      this.company = await [
        {
          content: `
        <p>
        <b style="font-size: 18px"><u>Föreningsuppgifter</u></b>
        <br>
        <b>Org.nr </b>: 802535-2264
        <br>
        <b>Kontorsadress </b>: Lombiavägen 2
        <br>
        <b>Ort </b>: 981 36 Kiruna
        <br>
        <b>Län </b>: Norrbottens län
        <br>
        <br>
        <b>Mail</b>: info@npcpower.se
        <br>
        <b>Telefon</b>: 070-314 03 39
        <br>
        <br>
        Skicka ett mail direkt till <b> <a class="alt-link" href="mailto:info@npcpower.se">info@npcpower.se</a> </b> eller fyll i formuläret nedan.
        <br>
        <br>


        </p>
        `,
          description: '',
          title: 'NPC Power Club',
          urlToImage:
            'https://firebasestorage.googleapis.com/v0/b/nordicperformancecenter-57600.appspot.com/o/NPCPowerClub%2Flogos%2FNPCPowerLogo.png?alt=media'
        },

        {
          content: `
        <p>
        <b>André Johansson:</b>
        <br>
        Skicka ett mail direkt till <b> <a class="alt-link" href="mailto:info@npcpower.se">info@npcpower.se</a> </b> eller fyll i formuläret nedan.
        <br>
        <br>
        <b>Mail</b>: info@npcpower.se
        <br>
        <b>Telefon</b>: 070-377 98 97
        <br>
        <br>
        </p>
        `,
          description: 'Jesper Naarttijärvi',
          title: 'Distrikt Kiruna',
          urlToImage:
             'https://firebasestorage.googleapis.com/v0/b/nordicperformancecenter-57600.appspot.com/o/NPCPowerClub%2Fwebsite%2Fcoacher%2FNPCPower_Coach_Andre_202104.png?alt=media'
        },
        {
          content: `
        <p>
        <b>Robin Lundén</b>
        <br>
        Skicka ett mail direkt till <b> <a class="alt-link" href="mailto:info@npcpower.se">info@npcpower.se</a> </b> eller fyll i formuläret nedan.
        <br>
        <br>
         <b>Mail</b>: info@npcpower.se
        <br>
        <b>Telefon</b>: 073-032 30 29
        <br>
        <br>
        </p>
        `,
          description: 'Jesper Naarttijärvi',
          title: 'Distrikt Boden',
          urlToImage:
             'https://firebasestorage.googleapis.com/v0/b/nordicperformancecenter-57600.appspot.com/o/NPCPowerClub%2Fwebsite%2Fcoacher%2FNPCPower_Coach_Robin_202104.JPG?alt=media'
        },
        {
          content: `
        <p>
        <b>Christian Naarttijärvi</b>
        <br>
        Skicka ett mail direkt till <b> <a class="alt-link" href="mailto:christian@npcgym.se">christian@npcgym.se</a> </b> eller fyll i formuläret nedan.
        <br>
        <br>
         <b>Mail</b>: christian@npcgym.se
        <br>
        <b>Telefon</b>: 070-314 03 39
        <br>
        <br>
        </p>
        `,
          description: '',
          title: 'Distrikt Luleå',
          urlToImage:
              'https://firebasestorage.googleapis.com/v0/b/nordicperformancecenter-57600.appspot.com/o/website%2Fcontact%2Fnpc_contact_christian.534f85e9.jpg?alt=media'
        }
      ]

      this.company.forEach((staff) => {
        this.question.push({
          sending: false,
          question: '',
          email: ''
        })
      })
    } catch (err) {
      this.error = err
      this.company = []
    }
  },
  computed: {
    ...mapGetters(['isMobile', 'flags']),
    questionFlag () {
      return this.flags['question']
    }
  },
  methods: {
    ...mapActions(['setFlag']),
    addNewLine (index) {
      this.question[index].question += '\n'
      console.log(this.question[index])
    },
    sendQuestion (index) {
      this.question[index].sending = true
      userHandler
        .sendAQuestion(this.question[index])
        .then((response) => {
          this.question[index].sending = false
          this.setFlag({
            key: 'question',
            value: {
              state: 1,
              msg: 'Frågan har skickats!'
            }
          })
        })
        .catch((err) => {
          this.question[index].sending = false
          this.setFlag({
            key: 'question',
            value: {
              state: 2,
              msg: 'Ett fel inträffade, försök igen.'
            }
          })
          log.error(err)
        })
    },
    status (validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      }
    }
  }
}
</script>

<style scoped lang="less">
@import '../styles/variables';
#contact {
  padding-top: 90px;
  margin-top: 10px;
  max-width: 1200px;
  margin: 0 auto;
}
.alt-link {
  color: @color-secondary-dark;
}
.contactText {
  font-size: 18px;
  line-height: 1.3;
}
</style>
